"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const customEventSaga_1 = require("../customEvent/customEventSaga");
const createDynamicModuleLoaderCustomEvent = () => ({
    id: 'custom-event',
    sagas: [customEventSaga_1.default],
});
exports.default = createDynamicModuleLoaderCustomEvent;
